import React from "react";

const Pagination = ({
  currentPage,
  totalPages,
  onPreviousPage,
  onNextPage,
  onPageChange,
}) => {
  const pageNumbers = Array.from(
    { length: totalPages },
    (_, index) => index + 1
  );

  // Display page numbers around the current page, with ellipsis for a large number of pages
  const renderPageNumbers = () => {
    if (totalPages <= 5) {
      return pageNumbers;
    }
    const pages = [];
    if (currentPage <= 3) {
      pages.push(...pageNumbers.slice(0, 5));
      pages.push("...");
    } else if (currentPage >= totalPages - 2) {
      pages.push("...");
      pages.push(...pageNumbers.slice(-5));
    } else {
      pages.push("...");
      pages.push(currentPage - 1, currentPage, currentPage + 1);
      pages.push("...");
    }
    return pages;
  };

  return (
    <div className="flex justify-center items-center mt-6 space-x-4">
      <button
        className={`px-4 py-2 rounded ${
          currentPage === 1
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-blue-500 text-white hover:bg-blue-600"
        }`}
        onClick={onPreviousPage}
        disabled={currentPage === 1}
      >
        Previous
      </button>

      <div className="flex items-center space-x-2">
        {renderPageNumbers().map((page, index) => (
          <button
            key={index}
            className={`px-3 py-1 rounded ${
              page === currentPage
                ? "bg-blue-500 text-white"
                : page === "..."
                ? "text-gray-500"
                : "bg-gray-200 text-gray-600 hover:bg-blue-200"
            }`}
            onClick={() => page !== "..." && onPageChange(page)}
            disabled={page === "..."}
          >
            {page}
          </button>
        ))}
      </div>

      <button
        className={`px-4 py-2 rounded ${
          currentPage === totalPages
            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
            : "bg-blue-500 text-white hover:bg-blue-600"
        }`}
        onClick={onNextPage}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
